import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

/**
 * Temperatura do contato (migration 280): calculada no banco pelo histórico de
 * vendas, propostas e negociações — ninguém escolhe. Substitui a bolinha sem
 * texto de contacts.status (cartão do Pedro, 28/10/2026).
 */
export const TEMPERATURAS = {
  frio: {
    rotulo: "Frio",
    explicacao: "Contato sem interesse demonstrado até agora",
    classe: "border-sky-200 bg-sky-100 text-sky-800 dark:border-sky-900 dark:bg-sky-950/60 dark:text-sky-300",
  },
  morno: {
    rotulo: "Morno",
    explicacao: "Demonstrou algum interesse, ainda sem proposta",
    classe: "border-amber-200 bg-amber-100 text-amber-800 dark:border-amber-900 dark:bg-amber-950/60 dark:text-amber-300",
  },
  quente: {
    rotulo: "Quente",
    explicacao: "Interessado, em negociação ou com proposta enviada",
    classe: "border-red-200 bg-red-100 text-red-800 dark:border-red-900 dark:bg-red-950/60 dark:text-red-300",
  },
  cliente: {
    rotulo: "Cliente",
    explicacao: "Já tem uma cota/venda fechada com a North",
    classe: "border-emerald-200 bg-emerald-100 text-emerald-800 dark:border-emerald-900 dark:bg-emerald-950/60 dark:text-emerald-300",
  },
} as const;

export type Temperatura = keyof typeof TEMPERATURAS;

export const EtiquetaTemperatura = ({ valor }: { valor?: string | null }) => {
  const t = TEMPERATURAS[(valor ?? "frio") as Temperatura] ?? TEMPERATURAS.frio;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          {/* button: no celular o toque abre o balão (Tooltip do Radix abre no foco). */}
          <button
            type="button"
            onClick={(e) => e.preventDefault()}
            aria-label={`${t.rotulo}: ${t.explicacao}`}
            className={`inline-block cursor-default whitespace-nowrap rounded-[4px] border px-1.5 py-0.5 text-[10.5px] font-semibold ${t.classe}`}
          >
            {t.rotulo}
          </button>
        </TooltipTrigger>
        <TooltipContent>{t.explicacao}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
